import { useMemo, useCallback } from "react";
import { useQuery, useMutation } from "@apollo/react-hooks";
import Context from "shared/util/Context";
import gql from "graphql-tag";
import get from "lodash/get";

const GET_USER_GUIDE = gql`
	query WebGetUserGuide($userid: String!, $userGuide: UserGuide!) {
		user(id: $userid) {
			id
			hasSeenUserGuide(feature: $userGuide)
		}
	}
`;

const MARK_USER_GUIDE = gql`
	mutation WebMarkUserGuideAsSeen($input: UserGuideSetHasSeenInput!) {
		userGuideSetHasSeen(input: $input) {
			success
		}
	}
`;

/**
 * Get and maybe set a user guide.
 * @param {string} userGuide - the user guide you'd like to check.
 * @param {object} [options] - useQuery options.
 * @returns {Object} - an object including hasSeenUserGuide, userGuideResponse, markUserGuideAsSeen
 */
function useUserGuide(userGuide, options = {}) {
	const userid = Context.get("userid");
	const queryOptions = { variables: { userid, userGuide }, ...options };
	const userGuideResponse = useQuery(GET_USER_GUIDE, queryOptions);
	const [markAsSeenMutation] = useMutation(MARK_USER_GUIDE);
	const hasSeenUserGuide = get(userGuideResponse, "data.user.hasSeenUserGuide");

	const markUserGuideAsSeen = useCallback((feature, mutationOptions = {}) => {
		return markAsSeenMutation({
			variables: {
				input: { feature },
			},
			...mutationOptions,
		});
	}, [markAsSeenMutation]);

	return useMemo(() => ({
		hasSeenUserGuide,
		userGuideResponse,
		markUserGuideAsSeen,
	}), [hasSeenUserGuide, userGuideResponse, markUserGuideAsSeen]);
}

export default useUserGuide;



// WEBPACK FOOTER //
// ./src/shared/hooks/useUserGuide.js